import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import LazyLoader from '../Common-features/LazyLoader';
import { Link, useNavigate } from 'react-router-dom';
const ProductBanner = ({ data, openModal }) => {
    
    useEffect(() => {
        AOS.init({
            once: false,
        });
    }, [])
    const path= window.location.pathname
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/request-a-demo', { state: { ttl2: "Request a Demo" ,dec:"Experience our innovation firsthand: Request a demo now!",path:{path} } });
    };


    return (

        <section className='banner-product-devl'>
            <div className='banner-caption-sec'>
                <div className='container'>
                    <div className='caption-banner'>
                        <div className='ban-caption'>
                            <h1 className='big-ttl' id='heading' dangerouslySetInnerHTML={{ __html: data[0].title }}></h1>
                            <button className='btn' onClick={handleClick}>
                                <span>{data[0].bannerBtnText}</span>
                            </button>
                        </div>
                        <div className='banr-img'>
                            <LazyLoader src={data[0].bannerBigimg} alt="" className='img-fluid banner-big-img' width="517" height="481" />
                            <LazyLoader src={data[0].bannerSmallImg} alt="" className='img-fluid banner-small-img' width="270" height="244" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ProductBanner